import rentObjectPricesService from "@/services/rentObjectPricesService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      await rentObjectPricesService.create(formData);
      dispatch(
        "common/showSuccess",
        "Preis wurde erfolgreich gespeichert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Preis konnte nicht gespeichert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }, formData) {
    try {
      const res = await rentObjectPricesService.findAll(formData);
      commit("setAll", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Preise für dieses Objekt konnten nicht geladen werden." + error,
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async update({ dispatch }, formData) {
    try {
      await rentObjectPricesService.update(formData);
      dispatch(
        "common/showSuccess",
        "Preis wurden aktualisiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Startdatum ist bereits vergeben.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await rentObjectPricesService.delete({ id });
      dispatch(
        "common/showSuccess",
        "Preis wurde erfolgreich gelöscht.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Preis für dieses Objekt konnte nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
